import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Layout } from "@/components/layout/Layout";
import { LanguageProvider } from "@/i18n/LanguageContext";

import Home from "@/pages/Home";
import PracticeAreaDetail from "@/pages/PracticeAreaDetail";
import About from "@/pages/About";
import CaseResults from "@/pages/CaseResults";
import InsightsList from "@/pages/InsightsList";
import InsightDetail from "@/pages/InsightDetail";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import AttorneyAdvertising from "@/pages/AttorneyAdvertising";
import LocationDetail from "@/pages/LocationDetail";
import AdminLogin from "@/pages/AdminLogin";
import AdminLeads from "@/pages/AdminLeads";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/practice-areas/:slug" element={<PracticeAreaDetail />} />
            <Route path="/about" element={<About />} />
            <Route path="/case-results" element={<CaseResults />} />
            <Route path="/insights" element={<InsightsList />} />
            <Route path="/insights/:slug" element={<InsightDetail />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/attorney-advertising" element={<AttorneyAdvertising />} />
            <Route path="/locations/:city" element={<LocationDetail />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/leads" element={<AdminLeads />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
